import axios from 'axios';
import { PUB_API_HOST } from './config';
import { convertToMysqlDate, formatFullDate, formatFullDateEndOfMonth } from './utils';

export const getAssignmentsUrl = `https://${PUB_API_HOST}/api/v2/public/booking/assignments`;
export const bookingUrl = `https://${PUB_API_HOST}/api/v2/public/booking`;

export const get = async (endpoint) => {
    // noinspection UnnecessaryLocalVariableJS
    const response = await axios.get(endpoint);
    return response;
};
export const post = async (endpoint, body) => {
    // noinspection UnnecessaryLocalVariableJS
    const response = await axios.post(endpoint, body);
    return response;
};

export const getBranches = () => async (baseUrl) => {
    try {
        // console.log('get branches', baseUrl);
        // noinspection UnnecessaryLocalVariableJS
        const res = await get(`${baseUrl}/branches`);
        return res;
    } catch (e) {
        throw e.response.data;
    }
};
export const getDoctors = () => async (baseUrl) => {
    try {
        // console.log('get doctors', baseUrl);
        // noinspection UnnecessaryLocalVariableJS
        const res = await get(`${baseUrl}/doctors`);
        return res;
    } catch (e) {
        throw e.response.data;
    }
};

export const getTimeslots = async (branchId, date, specializationId) => async (baseUrl) => {
    const query = `branchId=${branchId}&date=${convertToMysqlDate(date)}${specializationId ? `&specialityId=${specializationId}` : ''}`;
    try {
        // noinspection UnnecessaryLocalVariableJS
        const res = await get(
            `${baseUrl}/doctors/timeslots?${query}`,
        );
        return res;
    } catch (e) {
        throw e?.response?.data;
    }
};

export const getDoctorTimeTable = async (assignmentId, dateStart, dateEnd) => async (baseUrl) => {
    const query = `${baseUrl}/doctors/${assignmentId}/timeslots?dateStart=${
        convertToMysqlDate(dateStart || formatFullDate(Date.now()))
    }&dateEnd=${convertToMysqlDate(dateEnd || formatFullDateEndOfMonth())}`;
    try {
        // noinspection UnnecessaryLocalVariableJS
        const res = await get(query);
        return res;
    } catch (e) {
        throw e?.response?.data;
    }
};

export const createAppointment = async (doctorId, timeslotId, _body, isDoctoraOnline) => async (baseUrl) => {
    const body = {
        apiClient: isDoctoraOnline ? 'DOKTORA_ONLINE' : 'ONLINE',
        ..._body,
    };
    try {
        // noinspection UnnecessaryLocalVariableJS
        const res = await post(`${baseUrl}/doctors/${doctorId}/timeslots/${timeslotId}`, body);
        return res;
    } catch (e) {
        throw e?.response?.data;
    }
};

export const getAssigmentsInfo = async (assignmentsIds) => {
    const query = `?ids=${assignmentsIds.join(',')}`;
    try {
        const res = await get(
            `${getAssignmentsUrl}${query}`,
        );
        return res.data;
    } catch (e) {
        throw e?.response?.data;
    }
};

export const retractConsent = async (providerCode, body) => {
    try {
        const res = await post(`${bookingUrl}/${providerCode}/consents/retract`, body);
    } catch (e) {
        throw e?.response?.data;
    }
};
